import { truncate } from 'utils'
import * as S from './TableLite.styled'

export default ({ text, truncate: length = 22, ...props }) => (
  <S.CellText {...props}>
    {text?.length < length || !text ? text : truncate(text, length)}
  </S.CellText>
)
